<div class="btn-group" ngbDropdown dropdownClass="hx-hide-dropdown" role="group">
  <i class="las la-question-circle" ngbDropdownToggle></i>
  <div class="dropdown-menu" ngbDropdownMenu>
    <div *ngFor="let c of list" ngbDropdownItem>
      {{ c.phone }} - {{ c.fullname }} (<span *ngIf="c.owner">{{ 'ord.managers-info.owner' | transloco }}</span><span *ngIf="!c.owner">{{ 'ord.managers-info.manager' | transloco }}</span>)
    </div>
  </div>
</div>
